import { Flex, MenuItem, Text, Tooltip } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';
import { useGlobalUI } from '@/components/GlobalUIProvider';
import WipeDeviceModal from '@/components/People/EmployeeProfile/WipeDeviceModal';
import { DeviceAsset } from '@/types/assets';
import WipeWindowsDeviceModal from '@/components/People/EmployeeProfile/WipeWindowsDeviceModal';
import { WINDOWS } from '@/components/People/EmployeeProfile/helpers/DevicePropertyHelpers';

type WipeDeviceMenuItemProps = {
  deviceAsset: DeviceAsset;
  employeeName: string;
  isLoading: boolean;
  disabledBecause?: string;
};

const WipeDeviceMenuItem = ({
  deviceAsset,
  employeeName,
  isLoading,
  disabledBecause,
}: WipeDeviceMenuItemProps) => {
  const { t } = useTranslation('assets');
  const { openModal, closeModal } = useGlobalUI();

  const handleWipeDevice = () => {
    // if device is Windows, open the new modal with the new options
    if (deviceAsset.device.osType === WINDOWS) {
      openModal(
        <WipeWindowsDeviceModal
          employeeName={employeeName}
          deviceAsset={deviceAsset}
          onCompleteWipe={closeModal}
          onCancel={closeModal}
        />
      );
    } else {
      openModal(
        <WipeDeviceModal
          employeeName={employeeName}
          deviceAsset={deviceAsset}
          onCompleteWipe={closeModal}
          onCancel={closeModal}
        />
      );
    }
  };

  const isDisabled = !!disabledBecause;

  return (
    <Tooltip
      maxWidth="30rem"
      content={disabledBecause}
      placement="left"
      disabled={!isDisabled}>
      <Flex width="100%">
        <MenuItem
          id="wipe-device-menu-item"
          onClick={handleWipeDevice}
          disabled={isLoading || isDisabled}>
          <Text intent="error">{t('assetDetailsButtonMenu.wipeDevice')}</Text>
        </MenuItem>
      </Flex>
    </Tooltip>
  );
};

export default WipeDeviceMenuItem;
